import { render, staticRenderFns } from "./ChatsOverviewUser.vue?vue&type=template&id=339d0b55&"
import script from "./ChatsOverviewUser.vue?vue&type=script&lang=js&"
export * from "./ChatsOverviewUser.vue?vue&type=script&lang=js&"
import style0 from "./ChatsOverviewUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports